import { INetwork } from '@/types'

import { IWallet, IWalletConnectOptions, PsbtSignOptions, SignMessageOptions, TransactionOptions } from './types'

export abstract class BaseWallet implements IWallet {
  abstract name: string
  abstract key: string

  abstract connect(
    network: string,
    options: IWalletConnectOptions
  ): Promise<{ address: string; networkInfo: INetwork; compressedPublicKey: string | undefined }>

  abstract disconnect(networkId?: string): Promise<void>

  abstract sendTransaction(
    toAddress: string,
    amount: number | bigint, // after * 10**decimals
    network: string,
    options?: TransactionOptions
  ): Promise<string>

  abstract getAddress(networkId: string): Promise<string>

  abstract isInstalled(): boolean

  abstract signMessage(message: string, network: string, options?: SignMessageOptions): Promise<string>

  abstract getCompressedPublicKey(network: string): Promise<string>

  abstract signPsbt(psbt: string, network: string, options?: PsbtSignOptions): Promise<string>

  abstract priority(): number // 0 is the highest, -1 is not supported
}
